<template>
  <w-sliding-popup type="full" title="성능운영 타임라인" :visible="popupVisible" @close="close" ref="slidingPopup">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="end">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper :data="timelineList" :columns="tableColumns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="false" style="width:100%;">
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import mapApi from '@/api/virtual/performance/virtualmap';

export default {
  name: 'WVirtualMapTimelinePopup',
  data() {
    return {
      popupVisible: false,
      showSearchTool: false,
      timelineList: [],
      columnDefault,
      tableColumns: [
        { prop: 'timelineTarget', label: '대상명', width: 200, sortable: true, searchable: true },
        { prop: 'timelineTypeName', label: '타임라인 구분', width: 120, sortable: true, searchable: true },
        { prop: 'timelineMessage', label: '타임라인 메시지', sortable: true, searchable: true },
        { prop: 'timestamp', label: '발생시각', width: 160, sortable: true, searchable: true, searchType: 'date', formatter: this.convertTimestamp },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  methods: {
    open() {
      this.popupVisible = true;
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.popupVisible = false;
      this.$refs.slidingPopup.visible = false;
      this.showSearchTool = false;
    },
    /**
     * 타임라인 조회
     * @author jeee12
     */
    loadData() {
      const params = {
        timelineTypes: ['EVENT', 'TROUBLE_TICKET', 'CONFIG_CHANGE', 'WORK'],
        objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
        virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
        objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
      };
      mapApi.getVirtualTimelineData(params).then((response) => {
        this.timelineList = response.data.data;
      });
    },
    convertTimestamp(row, column, value) {
      return value.split('.')[0];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapTimelinePopup.vue